import styled from "@emotion/styled";
import { useDeepCompareMemo } from "@react-hookz/web";

import type { ContentSchemaRenderProps } from "~/components/content/content-schema-render";

import type { ExtraProps } from ".";
import { Link as ContentSchemaRenderLink } from ".";

const getRenderLinkComponent = (extraProps: ExtraProps) => {
  const Component = (p: ContentSchemaRenderProps) => (
    <ContentSchemaRenderLink {...p} {...extraProps} />
  );
  return styled(Component)``;
};

export function useContentSchemaRenderLink(extraProps: ExtraProps) {
  const ComponentWithExtraProps = useDeepCompareMemo(
    () => getRenderLinkComponent(extraProps),
    [extraProps],
  );

  return {
    ComponentWithExtraProps,
  };
}
